<template>
  <div class="circle-label" @click="onCircle">
    <ObImg 
      v-if="circleInfo.avatar" 
      formatWidth="120"
      :lazy="true"
      :src="circleInfo.avatar" 
    />
    <svg-icon class="profile-image" v-else name="icon-profile"></svg-icon>
    <div class="circle-info">
      <div class="circle-name">
        <div class="name">{{ circleInfo.name || $t('myProfile') }}</div>
        <div class="tab" v-if="circleInfo?.circleTabInfo">{{ circleInfo?.circleTabInfo.name }}</div>
      </div>
      <div class="circle-join" v-if="(!circleType || circleType === 4) && circleInfo.id && circleInfo.id != '0'" @click.stop="openJoin">
        <div class="join">{{ $t('join') }}</div>
      </div>
      <div class="circle-join" v-else>
        <div class="join pending" v-if="circleType === 5">{{ $t('pending') }}</div>
        <div class="joined" v-else><svg-icon name="icon-arrow"></svg-icon></div>
      </div>
    </div>
  </div>
  <wapPopup v-if="!isWeb" v-model="isOpenJoin">
    <div class="dialog-wrap">
      <div class="body">
        <h2 class="heading">{{$t('requests')}}</h2>
        <van-field
          v-model="applyReason"
          ref="textarea"
          rows="1"
          autosize
          type="textarea"
          :maxlength="cloudConfig.circleUserApplyReasonLimit"
          show-word-limit/>
        <div class="footer">
          <button @click="isOpenJoin = false" class="button">{{$t('cancel')}}</button>
          <button class="button" :class="{disabled: applyReason.length === 0}" @click="submitJoin">{{$t('send')}}</button>
        </div>
      </div>
    </div>
  </wapPopup>
  <JoinCircle v-if="isWeb" v-model="isOpenJoin" :id="circleInfo.id" @onPending="onPending"/>
</template>
<script setup>
import { ref, getCurrentInstance, nextTick } from 'vue';
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useSystemStore } from '@/stores/system'
import JoinCircle from '@/views/circle/web/components/joinCircle.vue'
import http from '@/service'
const userStore = useUserStore()
const { uid } = storeToRefs(userStore)
const systemStore = useSystemStore()
const { 
  cloudConfig,
  isWeb
} = storeToRefs(systemStore)
const router = useRouter()
const { proxy } = getCurrentInstance()
const props = defineProps({
  circleInfo: {
    type: Object,
    default: () => {
      return {}
    }
  },
  loginIdentityType: {
    type: Number,
    default: 0
  }
})
let circleType = ref(props.loginIdentityType)
const isOpenJoin = ref(false)
const textarea = ref(null)
const applyReason = ref('')
const onCircle = () => {
  if (props.circleInfo.name) {
    router.push({
      name: 'circle',
      params: {
        id: props.circleInfo.id
      }
    })
  } else {
    router.push({
      name: 'user',
      params: {
        id: uid.value
      }
    })
  }
  
}
const openJoin = () => {
  if (props.circleInfo.type === 1 || props.circleInfo.type === 3) {
    isOpenJoin.value = true
    if(!isWeb.value) {
      nextTick(() => {
        textarea.value.focus()
      })
    }
  } else {
    submitJoin()
  }
}
const onPending = (val) => {
  circleType.value = val
}
const submitJoin = async () => {
  if (!applyReason.value && props.circleInfo.type === 1) {
    return
  }
  const params = {
    id: props.circleInfo.id,
    applyReason: applyReason.value
  }
  const { code, data, msg} = await http.joinCircle(params)
  if (code === 200 && data) {
    isOpenJoin.value = false
    
    circleType.value = props.circleInfo.type === 1 || props.circleInfo.type === 3 ? 5 : 3
    proxy.$toast({
      message: props.circleInfo.type === 1 || props.circleInfo.type === 3 ? msg :proxy.$t('joined'),
    })
  }
}
</script>
<style lang="postcss" scoped>
.circle-label {
  width: 100%;
  margin-top: 20px;
  display: flex;
  padding-left: 12px;
  box-sizing: border-box;
  align-items: center;
  background: var(--color-background-secondary);
  border-radius: 2px;
  min-height: 60px;

  .ob-image {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 2px;
    img {
      border-radius: 2px;
    }
  }
  .profile-image {
    width: 40px;
    height: 40px;
    border-radius: 2px;
    flex-shrink: 0;
    background: var(--theme);
  }
  .circle-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .circle-name {
      width: 0;
      flex: 1;
      margin-left: 12px;
      .name {
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 23px !important;
        max-width: calc(100vw - 120px);
      }
  
      .tab {
        max-width: calc(100vw - 120px);
        font-size: 12px;
        line-height: 16px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: var(--color-text-description);
      }
    }
    .circle-join {
      padding: 16px 12px;
      margin-left: 4px;
    }
    .join {
      font-family: 'orbit-M';
      padding: 4px 11px;
      font-size: 14px;
      border: 1px solid var(--line);
      display: flex;
      align-items: center;
      justify-content: center;
      height: 28px;
      box-sizing: content-box;
      flex-shrink: 0;
      color: var(--text-primary);
      min-width: 54px;
      box-sizing: border-box;
      border-radius: var(--border-radius-full);
      line-height: 14.4px !important;
    }
    .pending {
      color: var(--text-disabled);
    }
    .joined {
      width: 26px;
      height: 26px;
      border: 1px solid var(--line);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      border-radius: var(--border-radius-full);
      line-height: 14.4px !important;
      .svg-icon {
        width: 16px;
        height: 16px;
        margin-right: 3px;
      }
    }
  }
}
.dialog-wrap {
  .body {
    padding-top: 18px;
    .heading {
      font-family: orbit-M;
      font-size: 16px;
      height: 50px;
      line-height: 50px;
      text-align: center;
    }
    .van-cell {
      background: var(--background-selection);
    }
    .van-cell::after {
      border-bottom: none;
    }
    .footer {
      height: 58px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .button {
        font-family: orbit-R;
        font-size: 14px;
        color: themed('theme');
        background-color: transparent;
        border: 0;
        flex: 1;
      }
    }
  }
  :deep(.van-field__control) {
    box-sizing: content-box;
    border-bottom: 1px solid var(--text-primary);
  }
}
:deep(.van-field__control) {
  box-sizing: content-box;
  border-bottom: 1px solid var(--text-primary);
}
@media only screen and (min-width: 1023px) {
  .circle-label {
    cursor: pointer;
    width: auto;
    background: none;
    border: 1px solid var(--line);
    border-radius: 2px;
    padding-left: 16px;
    max-width: 100%;
    margin-top: 0;
    height: 60px;
    .circle-info {
      max-width: calc(100% - 40px);
    }
  }
  .circle-name {
    min-width: 148px;
    width: auto !important;
  }
}
</style>